var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.617,
    height: 27.229,
    viewBox: "0 0 24.617 27.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(-309.5 -568.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_458_",
    transform: "translate(319.466 579.042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.847,129.957a8.127,8.127,0,1,0-.147-9.868m6.525-.975a5.8,5.8,0,1,1-5.8,5.8A5.807,5.807,0,0,1,145.225,119.114Z",
    transform: "translate(-138.7 -116.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_462_",
    transform: "translate(322.508 583.677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.161,181.344h1.161V182.5a1.161,1.161,0,0,0,2.322,0v-1.161H183.8a1.161,1.161,0,0,0,0-2.322h-1.161v-1.161a1.161,1.161,0,1,0-2.322,0v1.161h-1.161a1.161,1.161,0,1,0,0,2.322Z",
    transform: "translate(-178 -176.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(317.833 579.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.734,132.569a8.134,8.134,0,1,1,8.134-8.134A8.144,8.144,0,0,1,125.734,132.569Zm0-14.411a6.277,6.277,0,1,0,6.277,6.277A6.286,6.286,0,0,0,125.734,118.158Z",
    transform: "translate(-117.6 -116.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(310 568.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M0,2.92A32.794,32.794,0,0,1,5.39,2.5c2.773,0,4.807.644,6.1,1.8a5.842,5.842,0,0,1,1.905,4.55A6.415,6.415,0,0,1,11.716,13.5a9.016,9.016,0,0,1-6.645,2.387,9.555,9.555,0,0,1-2.258-.2V24.4H0ZM2.807,13.409a9.365,9.365,0,0,0,2.326.224c3.39,0,5.451-1.648,5.451-4.644,0-2.875-2.034-4.258-5.133-4.258a11.788,11.788,0,0,0-2.644.224v8.455Z",
    transform: "translate(0 -2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProject);
export default __webpack_public_path__ + "static/media/create_project.aaf5de167f88959d3334b44b3a012524.svg";
export { ForwardRef as ReactComponent };